import React from 'react';
import PropTypes from 'prop-types';
import GeoViewport from '@mapbox/geo-viewport';
import './index.scss';

// Given an array like [{longitude: 42, latitude: 19}... ], determines the
// bounding box that contains all those points, in the format:
// [
// 5.668343999999995,
// 45.111511000000014,
// 5.852471999999996,
// 45.26800200000002
// ]
function getBoundingBox(array) {
  const longitudes = array.map((pair) => pair.longitude);
  const latitudes = array.map((pair) => pair.latitude);
  return [
    Math.min(...longitudes),
    Math.min(...latitudes), // Top left corner
    Math.max(...longitudes),
    Math.max(...latitudes), // Bottom right corner
  ];
}

// Given an array like [{longitude: 42, latitude: 19}... ], determines the
// center point and zoom level to contain all of those points, with given
// dimensions (like {width: 640, height: 480} and given margin (int)
function calculateViewport(array, size, margin = 15) {
  const boundingBox = getBoundingBox(array);
  const dimensions = [size.width - margin, size.height - margin];
  const results = GeoViewport.viewport(boundingBox, dimensions);
  return {
    longitude: results.center[0],
    latitude: results.center[1],
    zoom: results.zoom,
  };
}

export default class MapboxFixedMap extends React.Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    // If "markerList" is unspecified, use this for the marker.
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    markerColor: PropTypes.string,
    // MarkerList is an optional list of lat/lon objects to place markers
    markerList: PropTypes.arrayOf(PropTypes.object),
    markerSize: PropTypes.string, // S, m or l
    maxWidth: PropTypes.number.isRequired,
    zoom: PropTypes.number,
  };

  getImageURL() {
    const accessToken = window.settings.keys.mapbox;
    let markerColor = '#F15F4B';
    if (markerColor.indexOf('#') === 0) {
      markerColor = markerColor.substring(1);
    }

    // Generate markers
    let markerList = this.props.markerList;
    if (!markerList || markerList.length < 1) {
      if (!this.props.longitude || !this.props.latitude) {
        throw new Error('longitude or latitude not specified');
      }

      markerList = [
        {
          latitude: this.props.latitude,
          longitude: this.props.longitude,
        },
      ];
    }

    const markerSize = this.props.markerSize || 's';

    // Concatenate marker list into comma-separated string for mapbox api
    const markerString = markerList
      .map(
        (loc) =>
          `pin-${markerSize}+${markerColor}(${loc.longitude},${loc.latitude})`,
      )
      .join(',');

    let {longitude, latitude} = this.props;
    let zoom = this.props.zoom || 15; // 15 is default

    // If longitude and latitude are not specified, then we auto-calculate
    // Based on bounding box
    if (!this.props.longitude || !this.props.latitude) {
      // Just make it square based on height
      const size = {
        width: this.props.height,
        height: this.props.height,
      };
      ({longitude, latitude, zoom} = calculateViewport(markerList, size));
    }
    const username = 'tgeer';
    const styleId = 'cka5muugr18wq1ip7xinov68e';
    const height = this.props.height;
    const width = this.props.maxWidth;

    return `https://api.mapbox.com/styles/v1/${username}/${styleId}/static/${markerString}/${longitude},${latitude},${zoom}/${width}x${height}?access_token=${accessToken}`;
  }

  render() {
    const styles = {
      border: 0,
      height: this.props.height,
      backgroundImage: `url('${this.getImageURL()}')`,
    };
    return <div className='mapbox-fixed' style={styles} />;
  }
}
